import React from "react";
import { orderBy } from "lodash";
import Grid from "@material-ui/core/Grid";
import { BackButton, ActionButton, DataTable, PartnerModal } from "../../components";
import { useSnackbar } from "notistack";
import { useHistory } from "react-router-dom";
import { useQuery, useMutation } from "@apollo/client";
import { GET_SALES } from "../../apollo/queries";
import { CREATE_SALE_ORDER } from "../../apollo/mutations";
import { formatDate } from "../../utils";

const columns = [
  { id: "name", label: "REFERENCIA", minWidth: 170 },
  {
    id: "dateOrder",
    label: "FECHA",
    minWidth: 100,
    format: (value) => {
      return formatDate(new Date(value));
    },
  },
  {
    id: "partnerId",
    label: "CLIENTE",
    minWidth: 100,
    format: (value) => {
      return value.name;
    },
  },
];

const SaleScreen = () => {
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const [openPartner, setOpenPartner] = React.useState(false);
  const { data, refetch, loading } = useQuery(GET_SALES, { fetchPolicy: "cache-and-network", pollInterval: 60000 });
  const [createSaleOrder] = useMutation(CREATE_SALE_ORDER, {
    onCompleted: (result) => {
      history.push({ pathname: `/sales/${result.id}`, state: { create: true } });
    },
  });

  React.useEffect(() => {
    refetch();
  }, [refetch]);

  const onRowClick = (row) => {
    history.push(`/sales/${row.id}`);
  };

  const newSale = async (partnerId) => {
    try {
      const variables = { partnerId };
      await createSaleOrder({ variables });
    } catch (error) {
      enqueueSnackbar("Error en la conexión con el servidor", { variant: "error" });
      console.log(error);
    }
  };

  const onPartnerResult = (partner) => {
    setOpenPartner(false);
    if (partner) newSale(partner.id);
  };

  return (
    <React.Fragment>
      <Grid container>
        <Grid container>
          <Grid item sm style={{ marginRight: 20 }}>
            <BackButton />
          </Grid>
          <Grid item sm>
            <ActionButton onClick={() => setOpenPartner(true)}>Crear albarán</ActionButton>
          </Grid>
        </Grid>
        <Grid container item style={{ marginTop: 20 }}>
          <Grid item sm>
            <DataTable loading={loading} columns={columns} rows={data && orderBy(data.sales, ["name"], ["desc"])} height="80.8vh" {...{ onRowClick }} />
          </Grid>
        </Grid>
      </Grid>
      <PartnerModal customer open={openPartner} onResult={onPartnerResult} />
    </React.Fragment>
  );
};

export default SaleScreen;
